export default __webpack_public_path__ + "static/media/2.387c7e36.jpg";